// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"310":"d5c4fcf7","423":"e0c3e20d","561":"96d59ffb","626":"08a120ea","732":"b5e5bb6d","767":"5d43b70c","835":"686c0713","844":"9201d497","911":"c9966c07"}[chunkId] + ".chunk.js";
};